import React, { useEffect, useState, useContext } from 'react';
import { Box, InputLabel, Paper } from '@material-ui/core';
import BreadCrumbs from '../../../Core/Controls/Breadcrumb';
import { DefaultButton, SecondaryButton, TextBox, SelectBox, YesNoButton, CustomColorPicker, SingelSelect } from '../../../Core/FormInput';
import { Typography, Container } from '@material-ui/core';
import { SketchPicker } from 'react-color';
import Grid from '@material-ui/core/Grid';
import FormLabel from '@material-ui/core/FormLabel';
import { useHistory } from 'react-router-dom';
import { getPortalSettings, addPortalSettings, getOcrDocumentsListById } from '../../../Core/Service/Settings';
import { getWorkflows } from '../../../Core/Service/workflow-service';
import CustomeEditor from '../../../Core/CkEditor';
import './style.scss';
import AppContext from '../../../App/AppContext';
import TabView from '../../../Core/Controls/Tabs';
import { FormControlLabel } from '@material-ui/core';
import { SecondaryCheckbox } from '../../../Core/FormInput';
import { useMemo } from 'react';
import { AppStorage } from '../../../Core/Service/storage-service';
import { getByWorkflowIdAndHeaderId } from '../../../Core/Service/returnReason-service';
import FormatAlignLeftIcon from '@material-ui/icons/FormatAlignLeft';
import FormatAlignCenterIcon from '@material-ui/icons/FormatAlignCenter';
import FormatAlignRightIcon from '@material-ui/icons/FormatAlignRight';
import { IconButton, Tooltip } from '@material-ui/core';

const crumbs = [
    { name: 'Home', path: '/' },
    { name: 'Settings', path: '/', active: true }
];

const EwipModule = (props) => {
    const { state, handleClick, handleFieldChange, handleCkeditorstate, handleCheckbox, handleAlignment, handleBrakeTestDocumentChange, setState } = props;
    const { mAccountMenus, portalSettings } = useContext(AppContext);
    return (
        <div style={{ padding: '20px 20px' }}>
            <Grid container spacing={2}>
                <Grid xs={12} sm={6} md={6} lg={3} container item>
                    <Grid item xs={12} style={{ marginBottom: '5px' }}>
                        <FormLabel>Hide Work Accomplished and Failure Reasons?</FormLabel>
                    </Grid>
                    <YesNoButton
                        state={state.hideWorkAccomplishedAndFailureReasons}
                        name="hideWorkAccomplishedAndFailureReasons"
                        onYesClick={() => handleClick('hideWorkAccomplishedAndFailureReasons', true)}
                        onNoClick={() => handleClick('hideWorkAccomplishedAndFailureReasons', false)}
                    />
                </Grid>
                <Grid xs={12} sm={6} md={6} lg={3} container item>
                    <Grid item xs={12} style={{ marginBottom: '5px' }}>
                        <FormLabel>Show workflow steps as buttons?</FormLabel>
                    </Grid>
                    <YesNoButton
                        state={state.workflowStepOptionsAsButtonGroup}
                        name="workflowStepOptionsAsButtonGroup"
                        onYesClick={() => handleClick('workflowStepOptionsAsButtonGroup', true)}
                        onNoClick={() => handleClick('workflowStepOptionsAsButtonGroup', false)}
                    />
                </Grid>
                <Grid xs={12} sm={6} md={6} lg={3} container item>
                    <Grid item xs={12} style={{ marginBottom: '5px' }}>
                        <FormLabel>Display Part Stock Status?</FormLabel>
                    </Grid>
                    <YesNoButton
                        state={state.portalSettingDisplayPartStockStatus}
                        name="portalSettingDisplayPartStockStatus"
                        onYesClick={() => handleClick('portalSettingDisplayPartStockStatus', true)}
                        onNoClick={() => handleClick('portalSettingDisplayPartStockStatus', false)}
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={3} container>
                    <Grid item xs={12} style={{ marginBottom: '5px' }}>
                        <FormLabel shrink>Workflow - unassigned technician job</FormLabel>
                    </Grid>
                    <SelectBox
                        onChange={handleFieldChange}
                        value={state.portalSettingUnassignedTechnicianJobWorkflowID}
                        name="portalSettingUnassignedTechnicianJobWorkflowID"
                        List={state.workFlowList || []}
                    />
                </Grid>

                <Grid container item xs={12} sm={6} lg={3}>
                    <Grid xs={12} sm={6} md={7} item style={{ paddingRight: '15px' }}>
                        <FormLabel> Grid Refresh Time (seconds)</FormLabel>
                        <TextBox type="number" value={state.portalSettingGridRefreshTime} onChange={handleFieldChange} name="portalSettingGridRefreshTime" />
                    </Grid>
                    <Grid xs={12} sm={6} md={5} item>
                        <FormLabel> Tech Writeup Height</FormLabel>
                        <TextBox
                            type="number"
                            value={state.portalSettingTechnWriteupHeight}
                            onChange={handleFieldChange}
                            name="portalSettingTechnWriteupHeight"
                        />
                    </Grid>
                </Grid>
                <Grid xs={12} sm={6} md={6} lg={3} container item>
                    <Grid item xs={12} style={{ marginBottom: '5px' }}>
                        <FormLabel>Show Reg In Customer Rating Box?</FormLabel>
                    </Grid>
                    <YesNoButton
                        state={state.showRegNumberInCustomerRatingBox}
                        name="showRegNumberInCustomerRatingBox"
                        onYesClick={() => handleClick('showRegNumberInCustomerRatingBox', true)}
                        onNoClick={() => handleClick('showRegNumberInCustomerRatingBox', false)}
                    />
                </Grid>
                <Grid xs={12} sm={6} md={6} lg={3} container item>
                    <Grid item xs={12} style={{ marginBottom: '5px' }}>
                        <FormLabel>Save New Document Version?</FormLabel>
                    </Grid>
                    <YesNoButton
                        state={state.portalSettingSaveNewDoc}
                        name="portalSettingSaveNewDoc"
                        onYesClick={() => handleClick('portalSettingSaveNewDoc', true)}
                        onNoClick={() => handleClick('portalSettingSaveNewDoc', false)}
                    />
                </Grid>
                <Grid xs={12} sm={6} md={6} lg={3} container item>
                    <Grid item xs={12} style={{ marginBottom: '5px' }}>
                        <FormLabel>Show Tech Write Up Save Button?</FormLabel>
                    </Grid>
                    <YesNoButton
                        state={state.portalSettingsShowTechWriteUpSaveBtn}
                        name="portalSettingsShowTechWriteUpSaveBtn"
                        onYesClick={() => handleClick('portalSettingsShowTechWriteUpSaveBtn', true)}
                        onNoClick={() => handleClick('portalSettingsShowTechWriteUpSaveBtn', false)}
                    />
                </Grid>
                <Grid xs={12} sm={6} md={6} lg={3} container item>
                    <Grid item xs={12} style={{ marginBottom: '5px' }}>
                        <FormLabel>Show Tech Write Up Submit Button?</FormLabel>
                    </Grid>
                    <YesNoButton
                        state={state.portalSettingDisplaySubmitbutton}
                        name="portalSettingDisplaySubmitbutton"
                        onYesClick={() => handleClick('portalSettingDisplaySubmitbutton', true)}
                        onNoClick={() => handleClick('portalSettingDisplaySubmitbutton', false)}
                    />
                </Grid>
                <Grid xs={12} sm={6} md={6} lg={3} container item>
                    <Grid item xs={12} style={{ marginBottom: '5px' }}>
                        <FormLabel>Disallow technician signature on save button?</FormLabel>
                    </Grid>
                    <YesNoButton
                        state={state.portalSettingDisallowTechnicianSignatureOnSaveButton}
                        name="portalSettingDisallowTechnicianSignatureOnSaveButton"
                        onYesClick={() => handleClick('portalSettingDisallowTechnicianSignatureOnSaveButton', true)}
                        onNoClick={() => handleClick('portalSettingDisallowTechnicianSignatureOnSaveButton', false)}
                    />
                </Grid>
                <Grid xs={12} sm={6} md={6} lg={3} container item>
                    <Grid item xs={12} style={{ marginBottom: '5px' }}>
                        <FormLabel>Display Assigned Workflows?</FormLabel>
                    </Grid>
                    <YesNoButton
                        state={state.portalSettingDisplayAssignedWorkflows}
                        name="portalSettingDisplayAssignedWorkflows"
                        onYesClick={() => handleClick('portalSettingDisplayAssignedWorkflows', true)}
                        onNoClick={() => handleClick('portalSettingDisplayAssignedWorkflows', false)}
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={3} container>
                    <Grid item xs={12} style={{ marginBottom: '5px' }}>
                        <FormLabel shrink>Workflow - Notification</FormLabel>
                    </Grid>
                    <SelectBox
                        onChange={handleFieldChange}
                        value={state.portalSettingWorkflowNotification}
                        name="portalSettingWorkflowNotification"
                        List={[
                            { name: 'Off', id: '0' },
                            // { name: 'Always On', id: '1' },
                            { name: 'User Preference', id: '2' }
                        ]}
                    />
                </Grid>
                {/* <Grid item xs={12} sm={6} md={6} lg={3} container>
                    <Grid item xs={12} style={{ marginBottom: '5px' }}>
                        <FormLabel shrink>NightShift Workflow</FormLabel>
                    </Grid>
                    <SelectBox
                        onChange={handleFieldChange}
                        value={state.portalSettingNightShiftWorkflowID}
                        name="portalSettingNightShiftWorkflowID"
                        List={state.workFlowList || []}
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={3} container>
                    <Grid item xs={12} style={{ marginBottom: '5px' }}>
                        <FormLabel shrink>Return Reason</FormLabel>
                    </Grid>
                    <SelectBox
                        onChange={handleFieldChange}
                        value={state.portalSettingReturnReasonID}
                        name="portalSettingReturnReasonID"
                        List={state.returnReasonList || []}
                    />
                </Grid> */}
                <Grid item xs={12} md={12} lg={12} style={{ textAlign: 'left' }}>
                    <Typography variant="body2" color="secondary">
                        Loan Vehicle Terms & Conditions
                    </Typography>
                    <hr />
                    <CustomeEditor
                        data={state.portalSettingLoanVehicleTerms}
                        onChange={handleCkeditorstate('portalSettingLoanVehicleTerms')}
                        placeholder="Loan Vehicle Terms & Conditions"
                        name="portalSettingLoanVehicleTerms"
                    />
                </Grid>
                <Grid item xs={12} md={12} lg={12} style={{ textAlign: 'left' }}>
                    <Typography variant="body2" color="secondary">
                        Diagnostic Charges
                    </Typography>
                    <hr />
                    <CustomeEditor data={state.Diag} onChange={handleCkeditorstate('Diag')} placeholder="Add description here" name="Diag" />
                </Grid>
                <Grid item xs={12} md={12} lg={12} style={{ textAlign: 'left' }}>
                    <Typography variant="body2" color="secondary">
                        Cab Declaration
                    </Typography>
                    <hr />
                    <CustomeEditor data={state.Cab} onChange={handleCkeditorstate('Cab')} placeholder="Add description here" name="Cab" />
                </Grid>
                <Grid item xs={12} md={12} lg={12} style={{ textAlign: 'left' }}>
                    <Grid container alignItems="center" spacing={2}>
                        <Grid item>
                            <Typography style={{ marginTop: '6px' }} variant="body2" color="secondary">
                                Brake Test Declaration
                            </Typography>
                        </Grid>
                        <Grid item xs={12} sm={5} style={{ width: '100px' }}>
                            <SingelSelect
                                onChange={handleBrakeTestDocumentChange('portalSettingBrakeTestDocumentID')}
                                options={state.ocrDocOptions || []}
                                value={state.portalSettingBrakeTestDocumentID}
                                placeholder="Select brake test document"
                                style={{ minWidth: '250px' }}
                            />
                        </Grid>
                    </Grid>
                    <hr />
                    {/* <CustomeEditor data={state.Break} onChange={handleCkeditorstate('Break')} placeholder="Add description here" name="Break" /> */}
                    <TextBox
                        placeholder="Add description here"
                        value={state.Break}
                        onChange={handleFieldChange}
                        name="Break"
                        multiline
                        rows={5}
                        inputProps={{
                            style: {
                                textAlign: state.Break || 'left'
                            }
                        }}
                    />
                </Grid>
                <Grid item xs={12} md={12} lg={12} style={{ textAlign: 'left' }}>
                    <Typography variant="body2" color="secondary">
                        Quality Control
                    </Typography>
                    <hr />
                    <CustomeEditor data={state.Qual} onChange={handleCkeditorstate('Qual')} placeholder="Add description here" name="Qual" />
                </Grid>
                <Grid item xs={12} md={12} lg={12} style={{ textAlign: 'left' }}>
                    <Typography variant="body2" color="secondary">
                        Display Message
                    </Typography>
                    <hr />
                    <CustomeEditor data={state.Disp} onChange={handleCkeditorstate('Disp')} placeholder="Add display message here" name="Disp" />
                </Grid>
                <Grid item xs={12} md={12} lg={12} style={{ textAlign: 'left' }}>
                    <Typography variant="body2" color="secondary">
                       Wheel Removal Document Disclaimer
                    </Typography>
                    <hr />
                    <CustomeEditor data={state.WheelTorqueRemoval} onChange={handleCkeditorstate('WheelTorqueRemoval')} placeholder="Add wheel torque removal message here" name="WheelTorqueRemoval" />
                </Grid>
            </Grid>
            <Grid container item xs={12} sm={12}>
                <Grid item xs={12} md={12} lg={12} style={{ top: 0, textAlign: 'left', paddingTop: '15px' }}>
                    <Typography variant="body2" color="secondary">
                        User Grid Columns
                    </Typography>
                    <hr />
                </Grid>
                <Grid container style={{ textAlign: 'left' }} spacing={2}>
                    <Grid item xs={6} sm={4} md={2}>
                        <FormLabel>Action</FormLabel>
                        <TextBox
                            inputLabel="Action"
                            placeholder="Action"
                            value={state.portalSettingGridActionLabel}
                            onChange={handleFieldChange}
                            name="portalSettingGridActionLabel"
                        />
                    </Grid>
                    <Grid item xs={6} sm={4} md={2}>
                        <FormLabel>WIP No</FormLabel>
                        <TextBox
                            inputLabel="WIPNo"
                            placeholder="WIP No"
                            value={state.portalSettingGridWIPNoLabel}
                            onChange={handleFieldChange}
                            name="portalSettingGridWIPNoLabel"
                        />
                    </Grid>
                    <Grid item xs={6} sm={4} md={2}>
                        <FormLabel>Vehicle Reg</FormLabel>
                        <TextBox
                            inputLabel="VehicleReg"
                            placeholder="Vehicle Reg"
                            value={state.portalSettingGridVehicleRegLabel}
                            onChange={handleFieldChange}
                            name="portalSettingGridVehicleRegLabel"
                        />
                    </Grid>
                    <Grid item xs={6} sm={4} md={2}>
                        <FormLabel>Model</FormLabel>
                        <TextBox
                            inputLabel="Model"
                            placeholder="Model"
                            value={state.portalSettingGridModelLabel}
                            onChange={handleFieldChange}
                            name="portalSettingGridModelLabel"
                        />
                    </Grid>
                    <Grid item xs={6} sm={4} md={2}>
                        <FormLabel>Customer Name</FormLabel>
                        <TextBox
                            inputLabel="CustomerName"
                            placeholder="Customer Name"
                            value={state.portalSettingGridCustomerNameLabel}
                            onChange={handleFieldChange}
                            name="portalSettingGridCustomerNameLabel"
                        />
                    </Grid>
                    <Grid item xs={6} sm={4} md={2}>
                        <FormLabel>Date Due In</FormLabel>
                        <TextBox
                            inputLabel="DateDueIn"
                            placeholder="Date Due In"
                            value={state.portalSettingGridDateDueInLabel}
                            onChange={handleFieldChange}
                            name="portalSettingGridDateDueInLabel"
                        />
                    </Grid>
                    <Grid item xs={6} sm={4} md={2}>
                        <FormLabel>Date Due Out</FormLabel>
                        <TextBox
                            inputLabel="DateDueOut"
                            placeholder="Date Due Out"
                            value={state.portalSettingGridDateDueOutLabel}
                            onChange={handleFieldChange}
                            name="portalSettingGridDateDueOutLabel"
                        />
                    </Grid>
                    <Grid item xs={6} sm={4} md={2}>
                        <FormLabel>Return Reason</FormLabel>
                        <TextBox
                            inputLabel="ReturnReason"
                            placeholder="Return Reason"
                            value={state.portalSettingGridReturnReasonLabel}
                            onChange={handleFieldChange}
                            name="portalSettingGridReturnReasonLabel"
                        />
                    </Grid>
                    <Grid item xs={6} sm={4} md={2}>
                        <FormLabel>Branch</FormLabel>
                        <TextBox
                            inputLabel="Branch"
                            placeholder="Branch"
                            value={state.portalSettingGridBranchLabel}
                            onChange={handleFieldChange}
                            name="portalSettingGridBranchLabel"
                        />
                    </Grid>
                    <Grid item xs={6} sm={4} md={2}>
                        <FormLabel>Franchise</FormLabel>
                        <TextBox
                            inputLabel="Franchise"
                            placeholder="Franchise"
                            value={state.portalSettingGridFranchiseLabel}
                            onChange={handleFieldChange}
                            name="portalSettingGridFranchiseLabel"
                        />
                    </Grid>
                    <Grid item xs={6} sm={4} md={2}>
                        <FormLabel>Job Description</FormLabel>
                        <TextBox
                            inputLabel="JobDescription"
                            placeholder="Job Description"
                            value={state.portalSettingGridJobDescriptionLabel}
                            onChange={handleFieldChange}
                            name="portalSettingGridJobDescriptionLabel"
                        />
                    </Grid>
                    <Grid item xs={6} sm={4} md={2}>
                        <FormLabel>Account</FormLabel>
                        <TextBox
                            inputLabel="Account"
                            placeholder="Account"
                            value={state.portalSettingGridAccountLabel}
                            onChange={handleFieldChange}
                            name="portalSettingGridAccountLabel"
                        />
                    </Grid>
                    <Grid item xs={6} sm={4} md={2}>
                        <FormLabel>Created By</FormLabel>
                        <TextBox
                            inputLabel="CreatedBy"
                            placeholder="Created By"
                            value={state.portalSettingGridCreatedByLabel}
                            onChange={handleFieldChange}
                            name="portalSettingGridCreatedByLabel"
                        />
                    </Grid>
                    <Grid item xs={6} sm={4} md={2}>
                        <FormLabel>Assigned Date</FormLabel>
                        <TextBox
                            inputLabel="AssignedDate"
                            placeholder="Assigned Date"
                            value={state.portalSettingGridAssignedDateLabel}
                            onChange={handleFieldChange}
                            name="portalSettingGridAssignedDateLabel"
                        />
                    </Grid>
                    <Grid item xs={6} sm={4} md={2}>
                        <FormLabel>Time Taken</FormLabel>
                        <TextBox
                            inputLabel="TimeTaken"
                            placeholder="Time Taken"
                            value={state.portalSettingGridTimeTakenLabel}
                            onChange={handleFieldChange}
                            name="portalSettingGridTimeTakenLabel"
                        />
                    </Grid>
                    <Grid item xs={6} sm={4} md={2}>
                        <FormLabel>Status</FormLabel>
                        <TextBox
                            inputLabel="Status"
                            placeholder="Status"
                            value={state.portalSettingGridStatusLabel}
                            onChange={handleFieldChange}
                            name="portalSettingGridStatusLabel"
                        />
                    </Grid>
                    <Grid item xs={6} sm={4} md={2}>
                        <FormLabel>Assigned Days</FormLabel>
                        <TextBox
                            inputLabel="AssignedDays"
                            placeholder="Assigned Days"
                            value={state.portalSettingGridAssignedDaysLabel}
                            onChange={handleFieldChange}
                            name="portalSettingGridAssignedDaysLabel"
                        />
                    </Grid>
                    <Grid item xs={6} sm={4} md={2}>
                        <FormLabel>Chassis Number</FormLabel>
                        <TextBox
                            inputLabel="ChassisNumber"
                            placeholder="Chassis Number"
                            value={state.portalSettingGridChassisNumberLabel}
                            onChange={handleFieldChange}
                            name="portalSettingGridChassisNumberLabel"
                        />
                    </Grid>
                    <Grid item xs={6} sm={4} md={2}>
                        <FormLabel>Owning Operator</FormLabel>
                        <TextBox
                            inputLabel="OwningOperator"
                            placeholder="Owning Operator"
                            value={state.portalSettingGridOwningOperatorLabel}
                            onChange={handleFieldChange}
                            name="portalSettingGridOwningOperatorLabel"
                        />
                    </Grid>
                    <Grid item xs={6} sm={4} md={2}>
                        <FormLabel>Assigned User</FormLabel>
                        <TextBox
                            inputLabel="AssignedUser"
                            placeholder="Assigned User"
                            value={state.portalSettingGridJobAssignedUserLabel}
                            onChange={handleFieldChange}
                            name="portalSettingGridJobAssignedUserLabel"
                        />
                    </Grid>

                    <Grid item xs={6} sm={4} md={2}>
                        <FormLabel>Loan Vehicle</FormLabel>
                        <TextBox
                            inputLabel="LoanVehicle"
                            placeholder="Loan Vehicle"
                            value={state.portalSettingGridCourtesyCarReqLabel}
                            onChange={handleFieldChange}
                            name="portalSettingGridCourtesyCarReqLabel"
                        />
                    </Grid>
                    <Grid item xs={6} sm={4} md={2}>
                        <FormLabel>WIP Age</FormLabel>
                        <TextBox
                            inputLabel="LoanVehicle"
                            placeholder="Loan Vehicle"
                            value={state.portalSettingGridWIPAgeLabel}
                            onChange={handleFieldChange}
                            name="portalSettingGridWIPAgeLabel"
                        />
                    </Grid>
                    <Grid item xs={6} sm={4} md={2}>
                        <InputLabel>FM Or Warranty Label</InputLabel>
                        <TextBox
                            placeholder="FM Or Warranty Label"
                            value={state.portalSettingGridIsFMOrWarrantyLabel}
                            onChange={handleFieldChange}
                            name="portalSettingGridIsFMOrWarrantyLabel"
                        />
                    </Grid>
                    <Grid item xs={6} sm={4} md={2}>
                        <InputLabel>Breakdown Label</InputLabel>
                        <TextBox
                            placeholder="Breakdown Label"
                            value={state.portalSettingGridIsBreakdownLabel}
                            onChange={handleFieldChange}
                            name="portalSettingGridIsBreakdownLabel"
                        />
                    </Grid>

                    {/* <Grid item xs={6} sm={4} md={2}>
                        <FormLabel>Job Assigned User</FormLabel>
                        <TextBox
                            inputLabel="LoanVehicle"
                            placeholder="Loan Vehicle"
                            value={state.portalSettingGridJobAssignedUserLabel}
                            onChange={handleFieldChange}
                            name="portalSettingGridJobAssignedUserLabel"
                        />
                    </Grid> */}
                    {/* Night Shift Section */}
                    <Grid item xs={12} md={6} container direction="column">
                        <InputLabel required className="mandatoryfields" style={{ marginBottom: '8px' }}>
                            Night Shift
                        </InputLabel>
                        <Grid container direction="row" spacing={2}>
                            <Grid item xs>
                                <InputLabel style={{ fontSize: '0.8rem' }}>Label</InputLabel>
                                <TextBox
                                    placeholder="Night Shift Label"
                                    value={state.portalSettingGridIsNightShiftLabel}
                                    onChange={handleFieldChange}
                                    name="portalSettingGridIsNightShiftLabel"
                                />
                            </Grid>
                            <Grid item xs>
                                <InputLabel style={{ marginBottom: '8px', fontSize: '0.8rem' }}>Text Color</InputLabel>
                                <CustomColorPicker
                                    width="95%"
                                    name="portalSettingNightShiftTextColor"
                                    id="portalSettingNightShiftTextColor"
                                    color={state.portalSettingNightShiftTextColor}
                                    onChange={(updatedColor) =>
                                        setState((prev) => ({
                                            ...prev,
                                            portalSettingNightShiftTextColor: updatedColor.hex
                                        }))
                                    }
                                />
                            </Grid>
                            <Grid item xs>
                                <InputLabel style={{ marginBottom: '8px', fontSize: '0.8rem' }}>BG Color</InputLabel>
                                <CustomColorPicker
                                    width="95%"
                                    name="portalSettingNightShiftBgColor"
                                    id="portalSettingNightShiftBgColor"
                                    color={state.portalSettingNightShiftBgColor}
                                    onChange={(updatedColor) =>
                                        setState((prev) => ({
                                            ...prev,
                                            portalSettingNightShiftBgColor: updatedColor.hex
                                        }))
                                    }
                                />
                            </Grid>
                        </Grid>
                    </Grid>

                    {/* Customer Waiting Section */}
                    <Grid item xs={12} md={6} container direction="column">
                        <InputLabel required className="mandatoryfields" style={{ marginBottom: '8px' }}>
                            Customer Waiting
                        </InputLabel>
                        <Grid container direction="row" spacing={2}>
                            <Grid item xs>
                                <FormLabel style={{ fontSize: '0.8rem' }}>Label</FormLabel>
                                <TextBox
                                    inputLabel="CustomerWaiting"
                                    placeholder="Customer Waiting"
                                    value={state.portalSettingGridCustomerWaitingLabel}
                                    onChange={handleFieldChange}
                                    name="portalSettingGridCustomerWaitingLabel"
                                />
                            </Grid>
                            <Grid item xs>
                                <InputLabel style={{ marginBottom: '8px', fontSize: '0.8rem' }}>Text Color</InputLabel>
                                <CustomColorPicker
                                    width="95%"
                                    name="portalSettingCustomerWaitingTextColor"
                                    id="portalSettingCustomerWaitingTextColor"
                                    color={state.portalSettingCustomerWaitingTextColor}
                                    onChange={(updatedColor) =>
                                        setState((prev) => ({
                                            ...prev,
                                            portalSettingCustomerWaitingTextColor: updatedColor.hex
                                        }))
                                    }
                                />
                            </Grid>
                            <Grid item xs>
                                <InputLabel style={{ marginBottom: '8px', fontSize: '0.8rem' }}>BG Color</InputLabel>
                                <CustomColorPicker
                                    width="95%"
                                    name="portalSettingCustomerWaitingBgColor"
                                    id="portalSettingCustomerWaitingBgColor"
                                    color={state.portalSettingCustomerWaitingBgColor}
                                    onChange={(updatedColor) =>
                                        setState((prev) => ({
                                            ...prev,
                                            portalSettingCustomerWaitingBgColor: updatedColor.hex
                                        }))
                                    }
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            <Grid container spacing={2} item xs={12} sm={12} style={{ textAlign: 'left' }}>
                <Grid item xs={12} md={12} lg={12} style={{ top: 0, textAlign: 'left', paddingTop: '15px' }}>
                    <Typography variant="body2" color="secondary">
                        Workflow Button Visibility
                    </Typography>
                    <hr />
                </Grid>
                <Grid item xs={12} md={12} lg={12} style={{ top: 0, textAlign: 'left', marginTop: '-15px' }}>
                    <Typography variant="body2" color="primary" style={{ fontWeight: 'bold' }}>
                        Customer
                    </Typography>
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={2}>
                    <FormControlLabel
                        control={<SecondaryCheckbox checked={state.canCustomerViewNotesButton} onChange={handleCheckbox} name="canCustomerViewNotesButton" />}
                        label="Show Notes Button?"
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={2}>
                    <FormControlLabel
                        control={
                            <SecondaryCheckbox checked={state.canCustomerViewHistoryButton} onChange={handleCheckbox} name="canCustomerViewHistoryButton" />
                        }
                        label="Show History Button?"
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={2}>
                    <FormControlLabel
                        control={<SecondaryCheckbox checked={state.canCustomerViewSaveButton} onChange={handleCheckbox} name="canCustomerViewSaveButton" />}
                        label="Show Save Button?"
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={2}>
                    <FormControlLabel
                        control={
                            <SecondaryCheckbox
                                checked={state.canCustomerViewSaveAndCompleteButton}
                                onChange={handleCheckbox}
                                name="canCustomerViewSaveAndCompleteButton"
                            />
                        }
                        label="Show Save & Complete Button?"
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={2}>
                    <FormControlLabel
                        control={<SecondaryCheckbox checked={state.canCustomerViewReturnButton} onChange={handleCheckbox} name="canCustomerViewReturnButton" />}
                        label="Show Return Button?"
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={2}>
                    <FormControlLabel
                        control={
                            <SecondaryCheckbox
                                checked={state.canCustomerViewReturnReasonHistoryButton}
                                onChange={handleCheckbox}
                                name="canCustomerViewReturnReasonHistoryButton"
                            />
                        }
                        label="Show Return History Button?"
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={2}>
                    <FormControlLabel
                        control={
                            <SecondaryCheckbox
                                checked={state.canCustomerViewAllDocumentsButton}
                                onChange={handleCheckbox}
                                name="canCustomerViewAllDocumentsButton"
                            />
                        }
                        label="Show All Documents Button?"
                    />
                </Grid>

                <Grid item xs={12} md={12} lg={12} style={{ top: 0, textAlign: 'left' }}>
                    <Typography variant="body2" color="primary" style={{ fontWeight: 'bold' }}>
                        Auditor
                    </Typography>
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={2}>
                    <FormControlLabel
                        control={<SecondaryCheckbox checked={state.canAuditorViewNotesButton} onChange={handleCheckbox} name="canAuditorViewNotesButton" />}
                        label="Show Notes Button?"
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={2}>
                    <FormControlLabel
                        control={<SecondaryCheckbox checked={state.canAuditorViewHistoryButton} onChange={handleCheckbox} name="canAuditorViewHistoryButton" />}
                        label="Show History Button?"
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={2}>
                    <FormControlLabel
                        control={<SecondaryCheckbox checked={state.canAuditorViewSaveButton} onChange={handleCheckbox} name="canAuditorViewSaveButton" />}
                        label="Show Save Button?"
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={2}>
                    <FormControlLabel
                        control={
                            <SecondaryCheckbox
                                checked={state.canAuditorViewSaveAndCompleteButton}
                                onChange={handleCheckbox}
                                name="canAuditorViewSaveAndCompleteButton"
                            />
                        }
                        label="Show Save & Complete Button?"
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={2}>
                    <FormControlLabel
                        control={<SecondaryCheckbox checked={state.canAuditorViewReturnButton} onChange={handleCheckbox} name="canAuditorViewReturnButton" />}
                        label="Show Return Button?"
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={2}>
                    <FormControlLabel
                        control={
                            <SecondaryCheckbox
                                checked={state.canAuditorViewReturnReasonHistoryButton}
                                onChange={handleCheckbox}
                                name="canAuditorViewReturnReasonHistoryButton"
                            />
                        }
                        label="Show Return History Button?"
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={2}>
                    <FormControlLabel
                        control={
                            <SecondaryCheckbox
                                checked={state.canAuditorViewAllDocumentsButton}
                                onChange={handleCheckbox}
                                name="canAuditorViewAllDocumentsButton"
                            />
                        }
                        label="Show All Documents Button?"
                    />
                </Grid>
            </Grid>
            {portalSettings.portalSettingManageAccountEnabled && (
                <Grid container spacing={2} item xs={12} sm={12} style={{ textAlign: 'left' }}>
                    <Grid item xs={12} md={12} lg={12} style={{ top: 0, textAlign: 'left', paddingTop: '15px' }}>
                        <Typography variant="body2" color="secondary">
                            Management Accounts
                        </Typography>
                        <hr />
                    </Grid>

                    <Grid container spacing={2}>
                        {/* Actual Name */}
                        <Grid item xs={6} sm={4} md={2}>
                            <InputLabel style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                Actual Name
                                {/* Alignment Icons */}
                                <span style={{ marginLeft: 8 }}>
                                    <Tooltip title="Left Align">
                                        <IconButton
                                            size="small"
                                            onClick={() => handleAlignment('portalSettingMADashboardActualAlign', 'left')}
                                            color={state.portalSettingMADashboardActualAlign === 'left' ? 'primary' : 'default'}
                                        >
                                            <FormatAlignLeftIcon fontSize="small" />
                                        </IconButton>
                                    </Tooltip>
                                    <Tooltip title="Center Align">
                                        <IconButton
                                            size="small"
                                            onClick={() => handleAlignment('portalSettingMADashboardActualAlign', 'center')}
                                            color={state.portalSettingMADashboardActualAlign === 'center' ? 'primary' : 'default'}
                                        >
                                            <FormatAlignCenterIcon fontSize="small" />
                                        </IconButton>
                                    </Tooltip>
                                    <Tooltip title="Right Align">
                                        <IconButton
                                            size="small"
                                            onClick={() => handleAlignment('portalSettingMADashboardActualAlign', 'right')}
                                            color={state.portalSettingMADashboardActualAlign === 'right' ? 'primary' : 'default'}
                                        >
                                            <FormatAlignRightIcon fontSize="small" />
                                        </IconButton>
                                    </Tooltip>
                                </span>
                            </InputLabel>
                            <TextBox
                                placeholder="Actual Name"
                                value={state.portalSettingMADashboardActualName}
                                onChange={handleFieldChange}
                                name="portalSettingMADashboardActualName"
                                inputProps={{
                                    style: {
                                        textAlign: state.portalSettingMADashboardActualAlign || 'left'
                                    }
                                }}
                            />
                        </Grid>

                        {/* Budget Name */}
                        <Grid item xs={6} sm={4} md={2}>
                            <InputLabel style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                Budget Name
                                {/* Alignment Icons */}
                                <span style={{ marginLeft: 8 }}>
                                    <Tooltip title="Left Align">
                                        <IconButton
                                            size="small"
                                            onClick={() => handleAlignment('portalSettingMADashboardBudgetAlign', 'left')}
                                            color={state.portalSettingMADashboardBudgetAlign === 'left' ? 'primary' : 'default'}
                                        >
                                            <FormatAlignLeftIcon fontSize="small" />
                                        </IconButton>
                                    </Tooltip>
                                    <Tooltip title="Center Align">
                                        <IconButton
                                            size="small"
                                            onClick={() => handleAlignment('portalSettingMADashboardBudgetAlign', 'center')}
                                            color={state.portalSettingMADashboardBudgetAlign === 'center' ? 'primary' : 'default'}
                                        >
                                            <FormatAlignCenterIcon fontSize="small" />
                                        </IconButton>
                                    </Tooltip>
                                    <Tooltip title="Right Align">
                                        <IconButton
                                            size="small"
                                            onClick={() => handleAlignment('portalSettingMADashboardBudgetAlign', 'right')}
                                            color={state.portalSettingMADashboardBudgetAlign === 'right' ? 'primary' : 'default'}
                                        >
                                            <FormatAlignRightIcon fontSize="small" />
                                        </IconButton>
                                    </Tooltip>
                                </span>
                            </InputLabel>
                            <TextBox
                                placeholder="Budget Name"
                                value={state.portalSettingMADashboardBudgetName}
                                onChange={handleFieldChange}
                                name="portalSettingMADashboardBudgetName"
                                inputProps={{
                                    style: {
                                        textAlign: state.portalSettingMADashboardBudgetAlign || 'left'
                                    }
                                }}
                            />
                        </Grid>

                        {/* Variance Name */}
                        <Grid item xs={6} sm={4} md={2}>
                            <InputLabel style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                Variance Name
                                {/* Alignment Icons */}
                                <span style={{ marginLeft: 8 }}>
                                    <Tooltip title="Left Align">
                                        <IconButton
                                            size="small"
                                            onClick={() => handleAlignment('portalSettingMADashboardVarianceAlign', 'left')}
                                            color={state.portalSettingMADashboardVarianceAlign === 'left' ? 'primary' : 'default'}
                                        >
                                            <FormatAlignLeftIcon fontSize="small" />
                                        </IconButton>
                                    </Tooltip>
                                    <Tooltip title="Center Align">
                                        <IconButton
                                            size="small"
                                            onClick={() => handleAlignment('portalSettingMADashboardVarianceAlign', 'center')}
                                            color={state.portalSettingMADashboardVarianceAlign === 'center' ? 'primary' : 'default'}
                                        >
                                            <FormatAlignCenterIcon fontSize="small" />
                                        </IconButton>
                                    </Tooltip>
                                    <Tooltip title="Right Align">
                                        <IconButton
                                            size="small"
                                            onClick={() => handleAlignment('portalSettingMADashboardVarianceAlign', 'right')}
                                            color={state.portalSettingMADashboardVarianceAlign === 'right' ? 'primary' : 'default'}
                                        >
                                            <FormatAlignRightIcon fontSize="small" />
                                        </IconButton>
                                    </Tooltip>
                                </span>
                            </InputLabel>
                            <TextBox
                                placeholder="Variance Name"
                                value={state.portalSettingMADashboardVarianceName}
                                onChange={handleFieldChange}
                                name="portalSettingMADashboardVarianceName"
                                inputProps={{
                                    style: {
                                        textAlign: state.portalSettingMADashboardVarianceAlign || 'left'
                                    }
                                }}
                            />
                        </Grid>

                        {/* KPIs Name */}
                        <Grid item xs={6} sm={4} md={2}>
                            <InputLabel style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                KPIs Name
                                {/* Alignment Icons */}
                                <span style={{ marginLeft: 8 }}>
                                    <Tooltip title="Left Align">
                                        <IconButton
                                            size="small"
                                            onClick={() => handleAlignment('portalSettingMADashboardKPIsAlign', 'left')}
                                            color={state.portalSettingMADashboardKPIsAlign === 'left' ? 'primary' : 'default'}
                                        >
                                            <FormatAlignLeftIcon fontSize="small" />
                                        </IconButton>
                                    </Tooltip>
                                    <Tooltip title="Center Align">
                                        <IconButton
                                            size="small"
                                            onClick={() => handleAlignment('portalSettingMADashboardKPIsAlign', 'center')}
                                            color={state.portalSettingMADashboardKPIsAlign === 'center' ? 'primary' : 'default'}
                                        >
                                            <FormatAlignCenterIcon fontSize="small" />
                                        </IconButton>
                                    </Tooltip>
                                    <Tooltip title="Right Align">
                                        <IconButton
                                            size="small"
                                            onClick={() => handleAlignment('portalSettingMADashboardKPIsAlign', 'right')}
                                            color={state.portalSettingMADashboardKPIsAlign === 'right' ? 'primary' : 'default'}
                                        >
                                            <FormatAlignRightIcon fontSize="small" />
                                        </IconButton>
                                    </Tooltip>
                                </span>
                            </InputLabel>
                            <TextBox
                                placeholder="KPIs Name"
                                value={state.portalSettingMADashboardKPIsName}
                                onChange={handleFieldChange}
                                name="portalSettingMADashboardKPIsName"
                                inputProps={{
                                    style: {
                                        textAlign: state.portalSettingMADashboardKPIsAlign || 'left'
                                    }
                                }}
                            />
                        </Grid>

                        {/* Actual PY Name */}
                        <Grid item xs={6} sm={4} md={2}>
                            <InputLabel style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                Actual PY Name
                                {/* Alignment Icons */}
                                <span style={{ marginLeft: 8 }}>
                                    <Tooltip title="Left Align">
                                        <IconButton
                                            size="small"
                                            onClick={() => handleAlignment('portalSettingMADashboardActualPYAlign', 'left')}
                                            color={state.portalSettingMADashboardActualPYAlign === 'left' ? 'primary' : 'default'}
                                        >
                                            <FormatAlignLeftIcon fontSize="small" />
                                        </IconButton>
                                    </Tooltip>
                                    <Tooltip title="Center Align">
                                        <IconButton
                                            size="small"
                                            onClick={() => handleAlignment('portalSettingMADashboardActualPYAlign', 'center')}
                                            color={state.portalSettingMADashboardActualPYAlign === 'center' ? 'primary' : 'default'}
                                        >
                                            <FormatAlignCenterIcon fontSize="small" />
                                        </IconButton>
                                    </Tooltip>
                                    <Tooltip title="Right Align">
                                        <IconButton
                                            size="small"
                                            onClick={() => handleAlignment('portalSettingMADashboardActualPYAlign', 'right')}
                                            color={state.portalSettingMADashboardActualPYAlign === 'right' ? 'primary' : 'default'}
                                        >
                                            <FormatAlignRightIcon fontSize="small" />
                                        </IconButton>
                                    </Tooltip>
                                </span>
                            </InputLabel>
                            <TextBox
                                placeholder="Actual PY Name"
                                value={state.portalSettingMADashboardActualPYName}
                                onChange={handleFieldChange}
                                name="portalSettingMADashboardActualPYName"
                                inputProps={{
                                    style: {
                                        textAlign: state.portalSettingMADashboardActualPYAlign || 'left'
                                    }
                                }}
                            />
                        </Grid>

                        {/* Var LY Name */}
                        <Grid item xs={6} sm={4} md={2}>
                            <InputLabel style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                Var PY Name
                                {/* Alignment Icons */}
                                <span style={{ marginLeft: 8 }}>
                                    <Tooltip title="Left Align">
                                        <IconButton
                                            size="small"
                                            onClick={() => handleAlignment('portalSettingMADashboardVarPYAlign', 'left')}
                                            color={state.portalSettingMADashboardVarPYAlign === 'left' ? 'primary' : 'default'}
                                        >
                                            <FormatAlignLeftIcon fontSize="small" />
                                        </IconButton>
                                    </Tooltip>
                                    <Tooltip title="Center Align">
                                        <IconButton
                                            size="small"
                                            onClick={() => handleAlignment('portalSettingMADashboardVarPYAlign', 'center')}
                                            color={state.portalSettingMADashboardVarPYAlign === 'center' ? 'primary' : 'default'}
                                        >
                                            <FormatAlignCenterIcon fontSize="small" />
                                        </IconButton>
                                    </Tooltip>
                                    <Tooltip title="Right Align">
                                        <IconButton
                                            size="small"
                                            onClick={() => handleAlignment('portalSettingMADashboardVarPYAlign', 'right')}
                                            color={state.portalSettingMADashboardVarPYAlign === 'right' ? 'primary' : 'default'}
                                        >
                                            <FormatAlignRightIcon fontSize="small" />
                                        </IconButton>
                                    </Tooltip>
                                </span>
                            </InputLabel>
                            <TextBox
                                placeholder="Var PY Name"
                                value={state.portalSettingMADashboardVarLYName}
                                onChange={handleFieldChange}
                                name="portalSettingMADashboardVarLYName"
                                inputProps={{
                                    style: {
                                        textAlign: state.portalSettingMADashboardVarPYAlign || 'left'
                                    }
                                }}
                            />
                        </Grid>
                        {/* Default Dashboard Section */}

                        <Grid container spacing={2} style={{ marginLeft: '2px' }} alignItems="flex-end">
                            {/* Negative Value Section */}
                            <Grid item xs={4} container direction="column" justifyContent="space-between">
                                <InputLabel required className="mandatoryfields" style={{ marginBottom: '8px' }}>
                                    Negative Value
                                </InputLabel>
                                <Grid container direction="row" spacing={2}>
                                    <Grid item xs={6}>
                                        <InputLabel style={{ marginBottom: '8px', fontSize: '0.8rem' }}>Text Color</InputLabel>
                                        <CustomColorPicker
                                            width="95%"
                                            name="portalSettingMADashboardNegativeTxtColor"
                                            id="portalSettingMADashboardNegativeTxtColor"
                                            color={state.portalSettingMADashboardNegativeTxtColor}
                                            onChange={(updatedColor) =>
                                                setState((prev) => ({
                                                    ...prev,
                                                    portalSettingMADashboardNegativeTxtColor: updatedColor.hex
                                                }))
                                            }
                                        />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <InputLabel style={{ marginBottom: '8px', fontSize: '0.8rem' }}>BG Color</InputLabel>
                                        <CustomColorPicker
                                            width="95%"
                                            name="portalSettingMADashboardNegativeBgColor"
                                            id="portalSettingMADashboardNegativeBgColor"
                                            color={state.portalSettingMADashboardNegativeBgColor}
                                            onChange={(updatedColor) =>
                                                setState((prev) => ({
                                                    ...prev,
                                                    portalSettingMADashboardNegativeBgColor: updatedColor.hex
                                                }))
                                            }
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item xs={4}>
                                <FormLabel style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                                    Default Dashboard
                                </FormLabel>
                                <SelectBox
                                    onChange={handleFieldChange}
                                    value={state.portalSettingDefaultDashboardID}
                                    name="portalSettingDefaultDashboardID"
                                    List={mAccountMenus?.menus || []}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            )}
        </div>
    );
};

const CommunicatorModule = (props) => {
    const { state, OnColorSelect } = props;
    const communicatorColorSections = [
        // {
        //     label: 'High Priority Job',
        //     textColorKey: 'portalHighPriorityJobTextColor',
        //     bgColorKey: 'portalHighPriorityJobColour',
        //     textColor: state.portalHighPriorityJobTextColor,
        //     bgColor: state.portalHighPriorityJobColour
        // }
    ];
    return (
        <div style={{ padding: '20px 20px' }}>
            <Grid container spacing={2}>
                {/* <Grid item container spacing={4} xs={12} md={3} sm={6}>
                    <Grid item xs={12} sm={12}>
                        <FormLabel component="legend">
                            <b>High Priority Job Colour</b>
                        </FormLabel>
                    </Grid>
                    <Grid item xs={12} md={3} sm={6}>
                        <SketchPicker
                            color={state.portalHighPriorityJobColour}
                            onChange={(updatedColor) => OnColorSelect(updatedColor, 'portalHighPriorityJobColour')}
                        />
                    </Grid>
                </Grid> */}
                <Grid container spacing={2}>
                    {communicatorColorSections.map((section) => (
                        <Grid item xs={12} sm={6} md={4} lg={3} xl={2} key={section.label}>
                            <Paper style={{ padding: 8, textAlign: 'center' }} elevation={3}>
                                <Box
                                    style={{
                                        backgroundColor: section.bgColor,
                                        color: section.textColor,
                                        padding: '3px 5px',
                                        borderRadius: 4,
                                        fontWeight: 'bold',
                                        marginBottom: 5
                                    }}
                                >
                                    {section.label}
                                </Box>

                                <Typography variant="caption" style={{ marginBottom: 3, color: '#555' }}>
                                    Text / Background
                                </Typography>

                                <Box display="flex" justifyContent="center" gridGap={4}>
                                    <CustomColorPicker
                                        height="20px"
                                        width="24px"
                                        name={section.textColorKey}
                                        id={section.textColorKey}
                                        color={section.textColor}
                                        // onChange={(updatedColor) =>
                                        //     setState((prev) => ({
                                        //         ...prev,
                                        //         [section.textColorKey]: updatedColor.hex
                                        //     }))
                                        // }
                                        onChange={(updatedColor) => OnColorSelect(updatedColor, [section.textColorKey])}
                                    />
                                    <CustomColorPicker
                                        height="20px"
                                        width="24px"
                                        name={section.bgColorKey}
                                        id={section.bgColorKey}
                                        color={section.bgColor}
                                        // onChange={(updatedColor) =>
                                        //     setState((prev) => ({
                                        //         ...prev,
                                        //         [section.bgColorKey]: updatedColor.hex
                                        //     }))
                                        // }
                                        onChange={(updatedColor) => OnColorSelect(updatedColor, [section.bgColorKey])}
                                    />
                                </Box>
                            </Paper>
                        </Grid>
                    ))}
                </Grid>
            </Grid>
        </div>
    );
};

const Settings = (props) => {
    const [state, setState] = useState({
        Title: '',
        CallUs: '',
        OpeningTimes: '',
        EmailUs: '',
        Diag: '',
        portalSettingLoanVehicleTerms: '',
        Cab: '',
        Break: '',
        Qual: '',
        Disp: '',
        WheelTorqueRemoval:'',
        HeaderTextColorCode: '',
        HeaderBackgroundColorCode: '',
        MenubarTextColorCode: '',
        MenubarBackgroundColorCode: '',
        portalSettingMyJobBgColor: '',
        // portalSettingMyJobTextColor: '',
        portalSettingTechnicianDeclaration: null,
        portalHighPriorityJobColour: '',
        portalHighPriorityJobTextColor: '',
        productLogo: '',
        labelLogo: '',
        bannerLogo: '',
        navigationMenuActive: '',
        bannerImage: '',
        Id: '',
        workflowStepOptionsAsButtonGroup: false,
        hideWorkAccomplishedAndFailureReasons: false,
        portalSettingUnassignedTechnicianJobWorkflowID: null,
        portalSettingWorkflowNotification: null,
        portalSettingDefaultDashboardID: null,
        isReload: new Date(),
        portalSettingSaveNewDoc: true,
        // portalSettingeWIPEnabled: false,
        // portalSettingReportingEnabled: false,
        portalSettingsShowTechWriteUpSaveBtn: false,
        portalSettingDisplaySubmitbutton: false,
        portalSettingDisallowTechnicianSignatureOnSaveButton: false,
        canCustomerViewNotesButton: false,
        canCustomerViewHistoryButton: false,
        canCustomerViewSaveButton: false,
        canCustomerViewSaveAndCompleteButton: false,
        canCustomerViewReturnButton: false,
        canCustomerViewReturnReasonHistoryButton: false,
        canCustomerViewAllDocumentsButton: false,
        canAuditorViewNotesButton: false,
        canAuditorViewHistoryButton: false,
        canAuditorViewSaveButton: false,
        canAuditorViewSaveAndCompleteButton: false,
        canAuditorViewReturnButton: false,
        canAuditorViewReturnReasonHistoryButton: false,
        canAuditorViewAllDocumentsButton: false,
        PortalSettingsPassowrdMinimumLength: 0,
        portalSettingDisplayAssignedWorkflows: false,
        portalSettingNightShiftWorkflowID: '',
        portalSettingReturnReasonID: '',
        portalSettingMADashboardActualAlign: 'left',
        portalSettingMADashboardBudgetAlign: 'left',
        portalSettingMADashboardVarianceAlign: 'left',
        portalSettingMADashboardKPIsAlign: 'left',
        portalSettingMADashboardActualPYAlign: 'left',
        portalSettingMADashboardVarPYAlign: 'left',
        portalSettingMADashboardNegativeTxtColor: '',
        portalSettingMADashboardNegativeBgColor: '',
        portalSettingNightShiftBgColor: '',
        portalSettingNightShiftTextColor: '',
        portalSettingCustomerWaitingTextColor: '',
        portalSettingCustomerWaitingBgColor: '',
        portalSettingBrakeTestDocumentID: null,
        portalSettingBrakeTestDocumentTempID: null,
        ocrDocOptions: [],
        portalSettingDueOver40DaysBgColor: '',
        portalSettingDueOver5DaysBgColor: '',
        portalSettingDueNowOrWithin5DaysBgColor: '',
        portalSettingDueOver40DaysTxtColor: '',
        portalSettingDueOver5DaysTxtColor: '',
        portalSettingDueNowOrWithin5DaysTxtColor: ''
    });
    const { showToast, portalSettings } = useContext(AppContext);

    const history = useHistory();

    const OnColorSelect = (updatedColor, name) => {
        setState((state) => ({
            ...state,
            [name]: updatedColor.hex
        }));
    };

    useEffect(() => {
        const loadOcrDocuments = async () => {
            try {
                const res = await getOcrDocumentsListById();
                if (res.success) {
                    setState((prev) => ({
                        ...prev,
                        ocrDocOptions: res.data.rows.map((m) => ({
                            id: m.id,
                            name: m.name
                        }))
                    }));
                }
            } catch (error) {
                console.error('Failed to load OCR Documents:', error);
                showToast('Error loading OCR Documents');
            }
        };
        loadOcrDocuments();
    }, []);

    useEffect(() => {
        if (state.portalSettingBrakeTestDocumentTempID && state.ocrDocOptions.length > 0) {
            const selectedDocument = state.ocrDocOptions.find((doc) => doc.id == state.portalSettingBrakeTestDocumentTempID);

            if (selectedDocument) {
                setState((prev) => ({
                    ...prev,
                    portalSettingBrakeTestDocumentID: selectedDocument
                }));
            }
        }
    }, [state.portalSettingBrakeTestDocumentTempID, state.ocrDocOptions]);

    const pullSettingsAndUpdateState = async () => {
        let res = await getPortalSettings();
        const data = res?.data?.details[0];
        if (res.success) {
            setState((st) => ({
                ...st,
                Id: data.portalSettingId,
                Title: data.portalSettingTitle,
                CallUs: data.portalSettingCallUs,
                OpeningTimes: data.portalSettingOpeningTime,
                EmailUs: data.portalSettingEmailUs,
                Diag: data.portalSettingDiagnosticCharges || '',
                portalSettingLoanVehicleTerms: data.portalSettingLoanVehicleTerms || '',
                Cab: data.portalSettingCabDeclaration || '',
                Break: data.portalSettingBrakeTestDeclaration || '',
                Qual: data.portalSettingQCMessage || '',
                Disp: data.portalSettingDisplayMessage || '',
                WheelTorqueRemoval: data.portalSettingWheelTorqueRemoval || '',
                HeaderTextColorCode: data.portalHeaderTextColour,
                HeaderBackgroundColorCode: data.portalHeaderBackgroundColour,
                MenubarTextColorCode: data.portalMenuBarTextColour,
                MenubarBackgroundColorCode: data.portalMenuBarBackgroundColour,
                portalSettingMyJobBgColor: data.portalSettingMyJobBgColor,
                // portalSettingMyJobTextColor: data.portalSettingMyJobTextColor,
                navigationMenuActive: data.portalSettingDisplayTopNavCounters,
                workflowStepOptionsAsButtonGroup: data.workflowStepOptionsAsButtonGroup,
                hideWorkAccomplishedAndFailureReasons: data.hideWorkAccomplishedAndFailureReasons || false,
                portalSettingSaveNewDoc: data.portalSettingSaveNewDoc,
                productLogo: data.portalSettingMainLogo,
                bannerLogo: data.portalSettingBanner,
                labelLogo: data.portalSettingAdditionalLogo,
                bannerImage: data.portalSettingBannerImage,
                portalSettingTechnicianDeclaration: data.portalSettingTechnicianDeclaration,
                portalSettingGridRefreshTime: data.portalSettingGridRefreshTime,
                portalSettingTechnWriteupHeight: data.portalSettingTechnWriteupHeight,
                portalSettingDisplayPartStockStatus: data.portalSettingDisplayPartStockStatus,

                portalSettingGridActionLabel: data.portalSettingGridActionLabel,
                portalSettingGridWIPNoLabel: data.portalSettingGridWIPNoLabel,
                portalSettingGridVehicleRegLabel: data.portalSettingGridVehicleRegLabel,
                portalSettingGridModelLabel: data.portalSettingGridModelLabel,
                portalSettingGridCustomerNameLabel: data.portalSettingGridCustomerNameLabel,
                portalSettingGridDateDueInLabel: data.portalSettingGridDateDueInLabel,
                portalSettingGridDateDueOutLabel: data.portalSettingGridDateDueOutLabel,
                portalSettingGridReturnReasonLabel: data.portalSettingGridReturnReasonLabel,
                portalSettingGridBranchLabel: data.portalSettingGridBranchLabel,
                portalSettingGridFranchiseLabel: data.portalSettingGridFranchiseLabel,
                portalSettingGridJobDescriptionLabel: data.portalSettingGridJobDescriptionLabel,
                portalSettingGridAccountLabel: data.portalSettingGridAccountLabel,
                portalSettingGridCreatedByLabel: data.portalSettingGridCreatedByLabel,
                portalSettingGridAssignedDateLabel: data.portalSettingGridAssignedDateLabel,
                portalSettingGridTimeTakenLabel: data.portalSettingGridTimeTakenLabel,
                portalSettingGridStatusLabel: data.portalSettingGridStatusLabel,
                portalSettingGridAssignedDaysLabel: data.portalSettingGridAssignedDaysLabel,
                portalSettingGridChassisNumberLabel: data.portalSettingGridChassisNumberLabel,
                portalSettingGridOwningOperatorLabel: data.portalSettingGridOwningOperatorLabel,
                portalSettingGridWIPAgeLabel: data.portalSettingGridWIPAgeLabel,
                portalSettingGridIsFMOrWarrantyLabel: data.portalSettingGridIsFMOrWarrantyLabel,
                portalSettingGridIsBreakdownLabel: data.portalSettingGridIsBreakdownLabel,
                portalSettingGridIsNightShiftLabel: data.portalSettingGridIsNightShiftLabel,
                // portalSettingGridJobAssignedUserLabel: data.portalSettingGridJobAssignedUserLabel,
                portalSettingUnassignedTechnicianJobWorkflowID: data.portalSettingUnassignedTechnicianJobWorkflowID,
                portalSettingWorkflowNotification: data.portalSettingWorkflowNotification,
                portalSettingDefaultDashboardID: data.portalSettingDefaultDashboardID,
                portalSettingGridCustomerWaitingLabel: data.portalSettingGridCustomerWaitingLabel,
                portalSettingGridCourtesyCarReqLabel: data.portalSettingGridCourtesyCarReqLabel,
                portalSettingGridJobAssignedUserLabel: data.portalSettingGridJobAssignedUserLabel,
                portalSettingTimeOut: data.portalSettingTimeOut,
                portalSettingPasswordExpiryDuration: data.portalSettingPasswordExpiryDuration,
                portalSettingsPassowrdMinimumLength: data.portalSettingsPassowrdMinimumLength,
                // portalSettingReportingEnabled: data.portalSettingReportingEnabled
                portalSettingSpecialEquipmentEnabled: data.portalSettingSpecialEquipmentEnabled,
                showRegNumberInCustomerRatingBox: data.showRegNumberInCustomerRatingBox,
                portalHighPriorityJobColour: data.portalHighPriorityJobColour || '',
                portalHighPriorityJobTextColor: data.portalHighPriorityJobTextColor || '',
                canCustomerViewNotesButton: data.canCustomerViewNotesButton,
                canCustomerViewHistoryButton: data.canCustomerViewHistoryButton,
                canCustomerViewSaveButton: data.canCustomerViewSaveButton,
                canCustomerViewSaveAndCompleteButton: data.canCustomerViewSaveAndCompleteButton,
                canCustomerViewReturnButton: data.canCustomerViewReturnButton,
                canCustomerViewReturnReasonHistoryButton: data.canCustomerViewReturnReasonHistoryButton,
                canCustomerViewAllDocumentsButton: data.canCustomerViewAllDocumentsButton,
                canAuditorViewNotesButton: data.canAuditorViewNotesButton,
                canAuditorViewHistoryButton: data.canAuditorViewHistoryButton,
                canAuditorViewSaveButton: data.canAuditorViewSaveButton,
                canAuditorViewSaveAndCompleteButton: data.canAuditorViewSaveAndCompleteButton,
                canAuditorViewReturnButton: data.canAuditorViewReturnButton,
                canAuditorViewReturnReasonHistoryButton: data.canAuditorViewReturnReasonHistoryButton,
                canAuditorViewAllDocumentsButton: data.canAuditorViewAllDocumentsButton,
                isReload: new Date(),
                portalSettingsShowTechWriteUpSaveBtn: data.portalSettingsShowTechWriteUpSaveBtn,
                portalSettingDisplaySubmitbutton: data.portalSettingDisplaySubmitbutton,
                portalSettingDisallowTechnicianSignatureOnSaveButton: data.portalSettingDisallowTechnicianSignatureOnSaveButton,
                portalSettingDisplayAssignedWorkflows: data.portalSettingDisplayAssignedWorkflows,
                portalSettingNightShiftWorkflowID: data.portalSettingNightShiftWorkflowID,
                portalSettingReturnReasonID: data.portalSettingReturnReasonID,
                portalSettingMADashboardActualName: data.portalSettingMADashboardActualName,
                portalSettingMADashboardBudgetName: data.portalSettingMADashboardBudgetName,
                portalSettingMADashboardVarianceName: data.portalSettingMADashboardVarianceName,
                portalSettingMADashboardKPIsName: data.portalSettingMADashboardKPIsName,
                portalSettingMADashboardActualPYName: data.portalSettingMADashboardActualPYName,
                portalSettingMADashboardVarLYName: data.portalSettingMADashboardVarLYName,

                portalSettingMADashboardActualAlign: data.portalSettingMADashboardActualAlign,
                portalSettingMADashboardBudgetAlign: data.portalSettingMADashboardBudgetAlign,
                portalSettingMADashboardVarianceAlign: data.portalSettingMADashboardVarianceAlign,
                portalSettingMADashboardKPIsAlign: data.portalSettingMADashboardKPIsAlign,
                portalSettingMADashboardActualPYAlign: data.portalSettingMADashboardActualPYAlign,
                portalSettingMADashboardVarPYAlign: data.portalSettingMADashboardVarPYAlign,
                portalSettingMADashboardNegativeTxtColor: data.portalSettingMADashboardNegativeTxtColor,
                portalSettingMADashboardNegativeBgColor: data.portalSettingMADashboardNegativeBgColor,
                portalSettingNightShiftBgColor: data.portalSettingNightShiftBgColor,
                portalSettingNightShiftTextColor: data.portalSettingNightShiftTextColor,
                portalSettingCustomerWaitingTextColor: data.portalSettingCustomerWaitingTextColor,
                portalSettingCustomerWaitingBgColor: data.portalSettingCustomerWaitingBgColor,

                portalSettingBrakeTestDocumentTempID: data.portalSettingBrakeTestDocumentID,
                portalSettingDueOver40DaysBgColor: data.portalSettingDueOver40DaysBgColor,
                portalSettingDueOver5DaysBgColor: data.portalSettingDueOver5DaysBgColor,
                portalSettingDueNowOrWithin5DaysBgColor: data.portalSettingDueNowOrWithin5DaysBgColor,
                portalSettingDueOver40DaysTxtColor: data.portalSettingDueOver40DaysTxtColor,
                portalSettingDueOver5DaysTxtColor: data.portalSettingDueOver5DaysTxtColor,
                portalSettingDueNowOrWithin5DaysTxtColor: data.portalSettingDueNowOrWithin5DaysTxtColor
            }));
        }
        if (!res.success) {
            console.log(res.message);
        }
    };
    let handleImage = (bannerLogo) => (event) => {
        let reader = new FileReader();
        reader.onload = (e) => {
            const { result } = e.target;
            setState((st) => ({
                ...st,
                [bannerLogo]: result
            }));
        };
        reader.readAsDataURL(event.target.files[0]);
    };

    const clearImage = (name) => (e) => {
        setState((st) => ({ ...st, [name]: null }));
    };

    const modelgridStyle = {
        formatterImageContainer: { width: '100%', textAlign: 'left' },
        //  formatterImage: { width: '40%', maxHeight: 60, backgroundSize: 'cover' },
        formatterImage: { width: 120, maxHeight: 60, backgroundSize: 'cover' }
    };

    const handleClick = (name, value) => {
        setState((st) => {
            const nst = { ...st, [name]: value };
            return nst;
        });
    };

    const handleBrakeTestDocumentChange = (name) => (event, value) => {
        const selectedDoc = state.ocrDocOptions.find((doc) => doc.id === value?.id);
        setState((prev) => ({
            ...prev,
            [name]: value
        }));
    };

    const handleFieldChange = (e) => {
        const { name, value } = e.target;
        setState((st) => ({ ...st, [name]: value }));
    };

    const handleSubmit = async () => {
        const data = {
            PortalSettingId: state.Id,
            PortalSettingCallUs: state.CallUs,
            PortalSettingOpeningTime: state.OpeningTimes,
            PortalSettingEmailUs: state.EmailUs,
            PortalSettingTitle: state.Title,
            PortalHeaderBackgroundColour: state.HeaderBackgroundColorCode,
            PortalHeaderTextColour: state.HeaderTextColorCode,
            PortalMenuBarBackgroundColour: state.MenubarBackgroundColorCode,
            portalSettingMyJobBgColor: state.portalSettingMyJobBgColor,
            // portalSettingMyJobTextColor: state.portalSettingMyJobTextColor,
            PortalMenuBarTextColour: state.MenubarTextColorCode,
            PortalSettingBannerImage: state.bannerImage,
            PortalSettingTechnicianDeclaration: state.portalSettingTechnicianDeclaration,
            PortalSettingQCMessage: state.Qual,
            PortalSettingDisplayMessage: state.Disp,
            PortalSettingWheelTorqueRemoval: state.WheelTorqueRemoval,
            PortalSettingDisplayTopNavCounters: state.navigationMenuActive,
            workflowStepOptionsAsButtonGroup: state.workflowStepOptionsAsButtonGroup,
            hideWorkAccomplishedAndFailureReasons: state.hideWorkAccomplishedAndFailureReasons,
            portalSettingSaveNewDoc: state.portalSettingSaveNewDoc,
            PortalSettingMainLogo: state.productLogo,
            PortalSettingBanner: state.bannerLogo,
            PortalSettingAdditionalLogo: state.labelLogo,
            PortalSettingDiagnosticCharges: state.Diag,
            portalSettingLoanVehicleTerms: state.portalSettingLoanVehicleTerms,
            PortalSettingCabDeclaration: state.Cab,
            PortalSettingBrakeTestDeclaration: state.Break,
            PortalSettingDisplayMessage: state.Disp,
            PortalSettingWheelTorqueRemoval: state.WheelTorqueRemoval,
            portalSettingGridRefreshTime: state.portalSettingGridRefreshTime,
            portalSettingTechnWriteupHeight: state.portalSettingTechnWriteupHeight,
            portalSettingDisplayPartStockStatus: state.portalSettingDisplayPartStockStatus,
            portalHighPriorityJobColour: state.portalHighPriorityJobColour,
            portalHighPriorityJobTextColor: state.portalHighPriorityJobTextColor,
            portalSettingGridActionLabel: state.portalSettingGridActionLabel || '',
            portalSettingGridWIPNoLabel: state.portalSettingGridWIPNoLabel || '',
            portalSettingGridVehicleRegLabel: state.portalSettingGridVehicleRegLabel || '',
            portalSettingGridModelLabel: state.portalSettingGridModelLabel || '',
            portalSettingGridCustomerNameLabel: state.portalSettingGridCustomerNameLabel || '',
            portalSettingGridDateDueInLabel: state.portalSettingGridDateDueInLabel || '',
            portalSettingGridDateDueOutLabel: state.portalSettingGridDateDueOutLabel || '',
            portalSettingGridReturnReasonLabel: state.portalSettingGridReturnReasonLabel || '',
            portalSettingGridBranchLabel: state.portalSettingGridBranchLabel || '',
            portalSettingGridFranchiseLabel: state.portalSettingGridFranchiseLabel || '',
            portalSettingGridJobDescriptionLabel: state.portalSettingGridJobDescriptionLabel || '',
            portalSettingGridAccountLabel: state.portalSettingGridAccountLabel || '',
            portalSettingGridCreatedByLabel: state.portalSettingGridCreatedByLabel || '',
            portalSettingGridAssignedDateLabel: state.portalSettingGridAssignedDateLabel || '',
            portalSettingGridTimeTakenLabel: state.portalSettingGridTimeTakenLabel || '',
            portalSettingGridStatusLabel: state.portalSettingGridStatusLabel || '',
            portalSettingGridAssignedDaysLabel: state.portalSettingGridAssignedDaysLabel || '',
            portalSettingGridChassisNumberLabel: state.portalSettingGridChassisNumberLabel || '',
            portalSettingGridOwningOperatorLabel: state.portalSettingGridOwningOperatorLabel || '',
            portalSettingGridJobAssignedUserLabel: state.portalSettingGridJobAssignedUserLabel || '',
            portalSettingUnassignedTechnicianJobWorkflowID: state.portalSettingUnassignedTechnicianJobWorkflowID || '',
            portalSettingWorkflowNotification: state.portalSettingWorkflowNotification || '',
            portalSettingDefaultDashboardID: state.portalSettingDefaultDashboardID || '',
            portalSettingGridCustomerWaitingLabel: state.portalSettingGridCustomerWaitingLabel || '',
            portalSettingGridCourtesyCarReqLabel: state.portalSettingGridCourtesyCarReqLabel || '',
            portalSettingGridWIPAgeLabel: state.portalSettingGridWIPAgeLabel || '',
            portalSettingGridIsFMOrWarrantyLabel: state.portalSettingGridIsFMOrWarrantyLabel || '',
            portalSettingGridIsBreakdownLabel: state.portalSettingGridIsBreakdownLabel || '',
            portalSettingGridIsNightShiftLabel: state.portalSettingGridIsNightShiftLabel || '',
            // portalSettingGridJobAssignedUserLabel: state.portalSettingGridJobAssignedUserLabel || '',
            portalSettingTimeOut: state.portalSettingTimeOut || '',
            portalSettingPasswordExpiryDuration: state.portalSettingPasswordExpiryDuration || null,

            portalSettingsPassowrdMinimumLength: state.portalSettingsPassowrdMinimumLength,
            portalSettingDisplayAssignedWorkflows: state.portalSettingDisplayAssignedWorkflows,
            portalSettingNightShiftWorkflowID: '', //state.portalSettingNightShiftWorkflowID,
            portalSettingReturnReasonID: '', // state.portalSettingReturnReasonID,
            // portalSettingReportingEnabled: state.portalSettingReportingEnabled
            portalSettingSpecialEquipmentEnabled: state.portalSettingSpecialEquipmentEnabled,
            showRegNumberInCustomerRatingBox: state.showRegNumberInCustomerRatingBox,

            canCustomerViewNotesButton: state.canCustomerViewNotesButton || false,
            canCustomerViewHistoryButton: state.canCustomerViewHistoryButton || false,
            canCustomerViewSaveButton: state.canCustomerViewSaveButton || false,
            canCustomerViewSaveAndCompleteButton: state.canCustomerViewSaveAndCompleteButton || false,
            canCustomerViewReturnButton: state.canCustomerViewReturnButton || false,
            canCustomerViewReturnReasonHistoryButton: state.canCustomerViewReturnReasonHistoryButton || false,
            canCustomerViewAllDocumentsButton: state.canCustomerViewAllDocumentsButton || false,
            canAuditorViewNotesButton: state.canAuditorViewNotesButton || false,
            canAuditorViewHistoryButton: state.canAuditorViewHistoryButton || false,
            canAuditorViewSaveButton: state.canAuditorViewSaveButton || false,
            canAuditorViewSaveAndCompleteButton: state.canAuditorViewSaveAndCompleteButton || false,
            canAuditorViewReturnButton: state.canAuditorViewReturnButton || false,
            canAuditorViewReturnReasonHistoryButton: state.canAuditorViewReturnReasonHistoryButton || false,
            canAuditorViewAllDocumentsButton: state.canAuditorViewAllDocumentsButton || false,
            portalSettingsShowTechWriteUpSaveBtn: state.portalSettingsShowTechWriteUpSaveBtn || false,
            portalSettingDisplaySubmitbutton: state.portalSettingDisplaySubmitbutton || false,
            portalSettingDisallowTechnicianSignatureOnSaveButton: state.portalSettingDisallowTechnicianSignatureOnSaveButton || false,
            portalSettingMADashboardActualName: state.portalSettingMADashboardActualName,
            portalSettingMADashboardBudgetName: state.portalSettingMADashboardBudgetName,
            portalSettingMADashboardVarianceName: state.portalSettingMADashboardVarianceName,
            portalSettingMADashboardKPIsName: state.portalSettingMADashboardKPIsName,
            portalSettingMADashboardActualPYName: state.portalSettingMADashboardActualPYName,
            portalSettingMADashboardVarLYName: state.portalSettingMADashboardVarLYName,

            portalSettingMADashboardActualAlign: state.portalSettingMADashboardActualAlign,
            portalSettingMADashboardBudgetAlign: state.portalSettingMADashboardBudgetAlign,
            portalSettingMADashboardVarianceAlign: state.portalSettingMADashboardVarianceAlign,
            portalSettingMADashboardKPIsAlign: state.portalSettingMADashboardKPIsAlign,
            portalSettingMADashboardActualPYAlign: state.portalSettingMADashboardActualPYAlign,
            portalSettingMADashboardVarPYAlign: state.portalSettingMADashboardVarPYAlign,
            portalSettingMADashboardNegativeTxtColor: state.portalSettingMADashboardNegativeTxtColor,
            portalSettingMADashboardNegativeBgColor: state.portalSettingMADashboardNegativeBgColor,
            portalSettingNightShiftBgColor: state.portalSettingNightShiftBgColor,
            portalSettingNightShiftTextColor: state.portalSettingNightShiftTextColor,
            portalSettingCustomerWaitingTextColor: state.portalSettingCustomerWaitingTextColor,
            portalSettingCustomerWaitingBgColor: state.portalSettingCustomerWaitingBgColor,

            portalSettingBrakeTestDocumentID: state.portalSettingBrakeTestDocumentID?.id || null,

            portalSettingDueOver40DaysBgColor: state.portalSettingDueOver40DaysBgColor,
            portalSettingDueOver5DaysBgColor: state.portalSettingDueOver5DaysBgColor,
            portalSettingDueNowOrWithin5DaysBgColor: state.portalSettingDueNowOrWithin5DaysBgColor,
            portalSettingDueOver40DaysTxtColor: state.portalSettingDueOver40DaysTxtColor,
            portalSettingDueOver5DaysTxtColor: state.portalSettingDueOver5DaysTxtColor,
            portalSettingDueNowOrWithin5DaysTxtColor: state.portalSettingDueNowOrWithin5DaysTxtColor
        };

        let res = await addPortalSettings(data);
        if (res.success) {
            const portalSettingsStr = AppStorage.getPortalSetting();
            if (portalSettingsStr) {
                // Parse the JSON string to get the object
                // Update the value of portalSettingsPasswordMinimumLength
                portalSettingsStr.portalSettingsPassowrdMinimumLength = +state.portalSettingsPassowrdMinimumLength;
                // Store the updated object back into localStorage
                AppStorage.setPortalSetting(portalSettingsStr);
            }
            showToast('Portal setting saved successfully');
            props.history.push('/');
        } else {
            showToast(res.message);
        }
    };

    useEffect(async () => {
        pullSettingsAndUpdateState();
        let result1 = await getWorkflows();
        setState((st) => ({
            ...st,
            workFlowList: result1.data.map((m) => ({ id: m.id, name: m.workflowName }))
        }));
    }, []);
    useEffect(async () => {
        if (state.portalSettingNightShiftWorkflowID) {
            let result1 = await getByWorkflowIdAndHeaderId(state.portalSettingNightShiftWorkflowID);
            setState((st) => ({
                ...st,
                returnReasonList: result1.data.returnReasons.map((q) => ({ id: q.returnReasonID, name: q.returnReasonDescription }))
            }));
        } else {
            setState((st) => ({
                ...st,
                returnReasonList: []
            }));
        }
    }, [state.portalSettingNightShiftWorkflowID]);

    const handleCkeditorstate = (name) => (event, editor) => {
        const data = editor.getData();
        setState((st) => ({ ...st, [name]: data }));
    };

    const handleCheckbox = (e, a) => {
        setState((st) => ({ ...st, [e.target.name]: a }));
    };

    const handleAlignment = (field, alignment) => {
        setState((prev) => ({
            ...prev,
            [field]: alignment
        }));
    };

    const tabs = [
        ...(portalSettings.portalSettingeWIPEnabled
            ? [
                  {
                      label: 'eWIP',
                      body: (
                          <EwipModule
                              state={state}
                              handleClick={handleClick}
                              handleFieldChange={handleFieldChange}
                              handleCkeditorstate={handleCkeditorstate}
                              handleCheckbox={handleCheckbox}
                              handleAlignment={handleAlignment}
                              handleBrakeTestDocumentChange={handleBrakeTestDocumentChange}
                              setState={setState}
                          />
                      )
                  }
              ]
            : []),
        // ...(portalSettings.portalSettingReportingEnabled
        //     ? [
        //           {
        //               label: 'Reporting',
        //               body: <></>
        //           }
        //       ]
        //     : null)
        ...(!portalSettings.portalSettingCommunicatorEnabled || true
            ? [
                  {
                      label: 'Communicator',
                      body: <CommunicatorModule state={state} OnColorSelect={OnColorSelect} />
                  }
              ]
            : [])
    ];

    const ewipColorSections = [
        {
            label: 'Header',
            textColorKey: 'HeaderTextColorCode',
            bgColorKey: 'HeaderBackgroundColorCode',
            textColor: state.HeaderTextColorCode,
            bgColor: state.HeaderBackgroundColorCode
        },
        {
            label: 'Menu Bar',
            textColorKey: 'MenubarTextColorCode',
            bgColorKey: 'MenubarBackgroundColorCode',
            textColor: state.MenubarTextColorCode,
            bgColor: state.MenubarBackgroundColorCode
        },
        {
            label: 'High Priority Job',
            textColorKey: 'portalHighPriorityJobTextColor',
            bgColorKey: 'portalHighPriorityJobColour',
            textColor: state.portalHighPriorityJobTextColor,
            bgColor: state.portalHighPriorityJobColour
        },
        {
            label: 'Overdue <= 5 Days',
            textColorKey: 'portalSettingDueNowOrWithin5DaysTxtColor',
            bgColorKey: 'portalSettingDueNowOrWithin5DaysBgColor',
            textColor: state.portalSettingDueNowOrWithin5DaysTxtColor,
            bgColor: state.portalSettingDueNowOrWithin5DaysBgColor
        },
        {
            label: 'Overdue > 40 Days',
            textColorKey: 'portalSettingDueOver40DaysTxtColor',
            bgColorKey: 'portalSettingDueOver40DaysBgColor',
            textColor: state.portalSettingDueOver40DaysTxtColor,
            bgColor: state.portalSettingDueOver40DaysBgColor
        },
        {
            label: 'Overdue > 5',
            textColorKey: 'portalSettingDueOver5DaysTxtColor',
            bgColorKey: 'portalSettingDueOver5DaysBgColor',
            textColor: state.portalSettingDueOver5DaysTxtColor,
            bgColor: state.portalSettingDueOver5DaysBgColor
        }

        // {
        //     label: 'Night Shift',
        //     textColorKey: 'portalSettingNightShiftTextColor',
        //     bgColorKey: 'portalSettingNightShiftBgColor',
        //     textColor: state.portalSettingNightShiftTextColor,
        //     bgColor: state.portalSettingNightShiftBgColor
        // },
        // {
        //     label: 'Customer Waiting',
        //     textColorKey: 'portalSettingCustomerWaitingTextColor',
        //     bgColorKey: 'portalSettingCustomerWaitingBgColor',
        //     textColor: state.portalSettingCustomerWaitingTextColor,
        //     bgColor: state.portalSettingCustomerWaitingBgColor
        // }
        // {
        //     label: 'My Job',
        //     textColorKey: 'portalSettingMyJobTextColor',
        //     bgColorKey: 'portalSettingMyJobBgColor',
        //     textColor: state.portalSettingMyJobTextColor,
        //     bgColor: state.portalSettingMyJobBgColor
        // }
    ];

    return (
        <div className="setting-screen" style={{ margin: 10 }}>
            <BreadCrumbs crumbs={crumbs} />
            <Grid container spacing={2}>
                <Grid item xs={12} sm={6} md={3}>
                    <FormLabel>Portal Title</FormLabel>
                    <TextBox inputLabel="Portal Title" placeholder="Portal Title" value={state.Title} onChange={handleFieldChange} name="Title" />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                    <FormLabel>Call Us</FormLabel>
                    <TextBox inputLabel="Call Us" placeholder="Number" value={state.CallUs} onChange={handleFieldChange} name="CallUs" />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                    <FormLabel>Opening Times</FormLabel>
                    <TextBox
                        inputLabel="Opening Times"
                        placeholder="Opening Times"
                        value={state.OpeningTimes}
                        onChange={handleFieldChange}
                        name="OpeningTimes"
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                    <FormLabel>Email Us</FormLabel>
                    <TextBox inputLabel="Email us" placeholder="Email us" value={state.EmailUs} onChange={handleFieldChange} name="EmailUs" />
                </Grid>
            </Grid>
            <Grid item container spacing={2}>
                <Grid item xs={12} md={12} lg={12} style={{ textAlign: 'left' }}>
                    <Typography variant="h5" color="secondary">
                        Colors
                    </Typography>
                    <hr />
                </Grid>
            </Grid>

            <Grid container spacing={2}>
                {ewipColorSections.map((section) => (
                    <Grid item xs={12} sm={6} md={4} lg={2} xl={'auto'} key={section.label}>
                        <Paper style={{ padding: 8, textAlign: 'center' }} elevation={3}>
                            <Box
                                style={{
                                    backgroundColor: section.bgColor,
                                    color: section.textColor,
                                    padding: '3px 5px',
                                    borderRadius: 4,
                                    fontWeight: 'bold',
                                    marginBottom: 5
                                }}
                            >
                                {section.label}
                            </Box>

                            <Typography variant="caption" style={{ marginBottom: 3, color: '#555' }}>
                                Text / Background
                            </Typography>

                            <Box display="flex" justifyContent="center" gridGap={4}>
                                <CustomColorPicker
                                    height="20px"
                                    width="24px"
                                    name={section.textColorKey}
                                    id={section.textColorKey}
                                    color={section.textColor}
                                    onChange={(updatedColor) =>
                                        setState((prev) => ({
                                            ...prev,
                                            [section.textColorKey]: updatedColor.hex
                                        }))
                                    }
                                />
                                <CustomColorPicker
                                    height="20px"
                                    width="24px"
                                    name={section.bgColorKey}
                                    id={section.bgColorKey}
                                    color={section.bgColor}
                                    onChange={(updatedColor) =>
                                        setState((prev) => ({
                                            ...prev,
                                            [section.bgColorKey]: updatedColor.hex
                                        }))
                                    }
                                />
                            </Box>
                        </Paper>
                    </Grid>
                ))}
            </Grid>

            <Grid container spacing={2} item xs={12} sm={12} style={{ textAlign: 'left', paddingTop: '15px' }}>
                <Grid item xs={12} md={12} lg={12}>
                    <Typography variant="h5" color="secondary">
                        Logos
                    </Typography>
                    <hr />
                </Grid>
                <Grid item xs={12} lg={3} sm={3} style={{ textAlign: 'left' }}>
                    <InputLabel shrink>Product Logo</InputLabel>
                    {state.productLogo ? (
                        <SecondaryButton onClick={clearImage('productLogo')}>Remove Logo</SecondaryButton>
                    ) : (
                        <input type="file" name="productLogo" onChange={handleImage('productLogo')} accept="image/*" />
                    )}
                </Grid>
                <Grid item xs={12} sm={3} lg={3} style={modelgridStyle.formatterImageContainer}>
                    <InputLabel shrink>{'\u{2800}'}</InputLabel>
                    {state.productLogo ? (
                        <img
                            src={state.productLogo?.includes('base64') ? state.productLogo : 'data:image/png;base64,' + state.productLogo}
                            alt={'logo'}
                            style={modelgridStyle.formatterImage}
                        />
                    ) : (
                        <p> Using default logo</p>
                    )}
                </Grid>
                <Grid item xs={12} lg={3} sm={3} style={{ textAlign: 'left' }}>
                    <InputLabel shrink style={{ paddingRight: '60px' }}>
                        Banner Image
                    </InputLabel>
                    {state.bannerLogo ? (
                        <SecondaryButton onClick={clearImage('bannerLogo')}>Remove Logo</SecondaryButton>
                    ) : (
                        <input type="file" name="bannerLogo" onChange={handleImage('bannerLogo')} accept="image/*" />
                    )}
                </Grid>
                <Grid item xs={12} sm={3} lg={3} style={modelgridStyle.formatterImageContainer}>
                    <InputLabel shrink>{'\u{2800}'}</InputLabel>
                    {state.bannerLogo ? (
                        <img
                            src={state.bannerLogo?.includes('base64') ? state.bannerLogo : 'data:image/png;base64,' + state.bannerLogo}
                            alt={'logo'}
                            style={modelgridStyle.formatterImage}
                        />
                    ) : (
                        <p> Using default image</p>
                    )}
                </Grid>
            </Grid>
            <Grid container item xs={12} sm={12}>
                <Grid item xs={12} md={12} lg={12} style={{ top: 0, textAlign: 'left' }}>
                    <Typography variant="h5" color="secondary">
                        Settings
                    </Typography>
                    <hr />
                </Grid>
                <Grid container style={{ textAlign: 'left' }} spacing={2}>
                    {/* <Grid xs={12} sm={6} md={3} container item>
                        <Grid item xs={12} style={{ marginBottom: '5px' }}>
                            <FormLabel>Display Top Navigation Counter?</FormLabel>
                        </Grid>
                        <YesNoButton
                            state={state.navigationMenuActive}
                            name="navigationMenuActive"
                            onYesClick={() => handleClick('navigationMenuActive', true)}
                            onNoClick={() => handleClick('navigationMenuActive', false)}
                        />
                    </Grid> */}
                    <Grid xs={12} sm={6} md={3} container item>
                        <Grid item xs={12}>
                            <InputLabel style={{ marginBottom: 7 }}>Session Timeout In Minutes</InputLabel>
                            <TextBox
                                inputLabel="Session Timeout In Minutes"
                                placeholder="Minutes"
                                value={state.portalSettingTimeOut}
                                onChange={handleFieldChange}
                                name="portalSettingTimeOut"
                            />
                        </Grid>
                    </Grid>
                    <Grid xs={12} sm={6} md={3} container item>
                        <Grid item xs={12}>
                            <InputLabel style={{ marginBottom: 7 }}>Password Expiry Duration In Days</InputLabel>
                            <TextBox
                                inputLabel="Session Timeout In Minutes"
                                placeholder="Days"
                                value={state.portalSettingPasswordExpiryDuration}
                                onChange={handleFieldChange}
                                name="portalSettingPasswordExpiryDuration"
                            />
                        </Grid>
                    </Grid>
                    <Grid xs={12} sm={6} md={3} container item>
                        <Grid item xs={12}>
                            <InputLabel style={{ marginBottom: 7 }}>Passowrd Minimum Length</InputLabel>
                            <TextBox
                                inputLabel="Passowrd Minimum Length"
                                placeholder="Days"
                                value={state.portalSettingsPassowrdMinimumLength}
                                onChange={handleFieldChange}
                                name="portalSettingsPassowrdMinimumLength"
                            />
                        </Grid>
                    </Grid>
                    {/* <Grid xs={12} sm={6} md={3} container item>
                        <Grid item xs={12}>
                            <InputLabel style={{ marginBottom: 7 }}>Display Assigned Workflows</InputLabel>
                            <TextBox
                                inputLabel="Passowrd Minimum Length"
                                placeholder=""
                                value={state.portalSettingDisplayAssignedWorkflows}
                                onChange={handleFieldChange}
                                name="portalSettingDisplayAssignedWorkflows"
                            />
                        </Grid>
                    </Grid>
                    <Grid xs={12} sm={6} md={3} container item>
                        <Grid item xs={12}>
                            <InputLabel style={{ marginBottom: 7 }}>NightShift Workflow ID</InputLabel>
                            <TextBox
                                inputLabel="Passowrd Minimum Length"
                                placeholder=""
                                value={state.portalSettingNightShiftWorkflowID}
                                onChange={handleFieldChange}
                                name="portalSettingNightShiftWorkflowID"
                            />
                        </Grid>
                    </Grid>
                    <Grid xs={12} sm={6} md={3} container item>
                        <Grid item xs={12}>
                            <InputLabel style={{ marginBottom: 7 }}>Return Reason ID</InputLabel>
                            <TextBox
                                inputLabel="Passowrd Minimum Length"
                                placeholder=""
                                value={state.portalSettingReturnReasonID}
                                onChange={handleFieldChange}
                                name="portalSettingReturnReasonID"
                            />
                        </Grid>
                    </Grid> */}
                </Grid>
            </Grid>
            <TabView tabList={tabs} id="testing_tabs" tabLableSize="1.2rem" tabLableWeight="700" />
            <Grid item xs={12} container spacing={2} style={{ marginTop: '10px' }}>
                <Grid item xs={6} className="submit_btn" style={{ textAlign: 'center' }}>
                    <SecondaryButton fullWidth onClick={handleSubmit}>
                        Save
                    </SecondaryButton>
                </Grid>
                <Grid item xs={6} className="submit_btn" style={{ textAlign: 'center' }}>
                    <SecondaryButton
                        fullWidth
                        onClick={() => {
                            props.history.push('/');
                        }}
                    >
                        Cancel
                    </SecondaryButton>
                </Grid>
            </Grid>
        </div>
    );
};

export default Settings;
